import { createRouter, createWebHistory } from 'vue-router'
import routes from '@helm/routes'
import permissionCheck from '@helm/middleware/router/permissionCheck'

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(permissionCheck)

export default router
